import axios from "axios";

export default function getAllRequisite(code) {
  return axios.get("/wallet/requisite", { params: { code } });
}
